import { FC } from 'react';
import { useQuery } from 'react-query';
import { observer } from 'mobx-react-lite';
import { useStore } from 'hooks/useRootStore';
import { useMyTranslations } from 'hooks/useMyTranslations';
import AdminUsersTable from 'components/Tables/AdminUsersTable';
import { AppLoader } from 'components/Core/AppLoader';
import { adminUsersTranslations } from './translations';
import { AdminUsersTransFields } from './types';
import styles from './adminUsers.module.scss';

const AdminUsers: FC = observer(() => {
  const {
    usersStore: { getAdminUsersData },
  } = useStore();

  const { t } = useMyTranslations<AdminUsersTransFields>([adminUsersTranslations.name]);

  const { isFetching } = useQuery('getUsersData', () => getAdminUsersData(), {
    retry: false,
    refetchOnWindowFocus: false,
  });

  return (
    <main className={styles.page}>
      <header className={styles.header}>
        <h2 className={styles.headerTitle}>{t('title')}</h2>
      </header>
      <div className={styles.container}>{isFetching ? <AppLoader /> : <AdminUsersTable />}</div>
    </main>
  );
});

export default AdminUsers;
